module.exports = __webpack_public_path__ + "static/media/general-booking.dde8dbe0.svg";